import 'vue';
import './helpers.mjs';
import './config.mjs';
import { b as registerComponent } from './plugins-6d013f3f.mjs';
import './Icon-3973158b.mjs';
import './FormElementMixin-f660a77c.mjs';
import { s as script } from './Input-45fe236f.mjs';
export { s as OInput } from './Input-45fe236f.mjs';

var index = {
    install(app) {
        registerComponent(app, script);
    }
};

export default index;
